import UserProfile from "../UserProfile";

export default function ProfileSection() {
  return <UserProfile />;
}
